import { Button, Typography } from '@braskai/ui-kit';
import { useNavigate } from 'react-router-dom';

import { CardMedia, Stack } from '@mui/material';

import NotFoundImage from '@/shared/assets/images/404.png';
import { PATHS } from '@/shared/constants/routes/paths';
import { useInterfaceLanguage } from '@/shared/i18n';

export const NotFoundError = () => {
  const { t } = useInterfaceLanguage();
  const navigate = useNavigate();

  return (
    <Stack alignItems="center" gap={20} justifyContent="center" minHeight="100%">
      <CardMedia
        sx={{
          height: 136,
          width: 234,
        }}
        alt="404"
        component="img"
        src={NotFoundImage}
      />
      <Stack gap={4} textAlign="center">
        <Typography color="grey.900" variant="title-3-md">
          {t('editor.error.pageMissing')}
        </Typography>

        <Typography color="grey.500" variant="body-1">
          {t('editor.error.pageMissingSubtitle')}
        </Typography>
      </Stack>

      <Button data-testid="not-found-error-go-home" size="lg" onClick={() => navigate(PATHS.homepage)}>
        {t('editor.action.goHome')}
      </Button>
    </Stack>
  );
};
